// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"ef4020b8","239":"6f28dbd1","453":"249196f4","667":"19fcc776","977":"250b70b1"}[chunkId] + ".chunk.js";
};